import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalCodeQuestionPageRoutingModule } from './modal-code-question-routing.module';

import { ModalCodeQuestionPage } from './modal-code-question.page';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ZXingScannerModule,
    ModalCodeQuestionPageRoutingModule
  ],
  declarations: [ModalCodeQuestionPage]
})
export class ModalCodeQuestionPageModule {}
